import React, { useCallback } from "react";
import ButtonBase from "@mui/material/ButtonBase";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AssetItemImage from "../../capture/aseet-list/AssetItemImage";

const styles = {
  button: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    border: 0,
    boxSizing: "border-box",
    borderBottom: "1px solid #DDDBDA",
    height: 180,
    textAlign: "left",
    width: "100%",
    overflow: "hidden",
    padding: "8px 8px",
    "&:hover": {
      backgroundColor: "#f4f6f8",
    },
  },
  checkbox: {
    mr: 1,
  },
  description: {
    width: "100%",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    wordBreak: "break-word",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 4,
  },
  arrow: {
    fontSize: 18,
    color: "action.active",
    ml: 1,
  },
};

export default function KitListItem({ order, asset, style, setSelected, checked, onCheck }) {
  const handleSelect = useCallback(
    async e => {
      if (e.target.type === "checkbox") return;
      setSelected(asset);
    },
    [asset, setSelected]
  );

  if (!asset) {
    return <div style={style} data-id="kits-list" />;
  }

  return (
    <div style={style} data-id="kits-list">
      <ButtonBase fullWidth variant="outlined" sx={styles.button} onClick={handleSelect}>
        <Checkbox
          checked={checked}
          onChange={() => onCheck && onCheck(asset)}
          disableRipple
          sx={styles.checkbox}
        />
        <AssetItemImage images={asset.images} />
        <Box ml="22px" overflow="hidden" display="flex" flexDirection="column" flexGrow={1}>
          <Typography variant="body2" lineHeight={1.2} color="primary" fontWeight={500}>
            {asset.itemId}
          </Typography>
          <Box width="100%" maxWidth="100%">
            <Typography
              sx={styles.description}
              color="textSecondary"
              lineHeight={1.3}
              component="div"
              variant="body2"
            >
              {asset.description}
            </Typography>
          </Box>
          <Typography variant="body2" lineHeight={1.2} color="textSecondary">
            Quantity: {asset.availableQuantity}
          </Typography>
        </Box>
        <ArrowForwardIosIcon sx={styles.arrow} />
      </ButtonBase>
    </div>
  );
}
